import request from '@/utils/request'

export function info(id) {
  return request({
    url: `/api/system/Permission/Users/${id}`,
    method: 'get'
  })
}

export function update(id, data) {
  return request({
    url: `/api/system/Permission/Users/${id}`,
    method: 'put',
    data: data
  })
}

export function save(data) {
  return request({
    url: `/api/system/Permission/Users`,
    method: 'post',
    data: data
  })
}

export function del(id) {
  return request({
    url: `/api/system/Permission/Users/${id}`,
    method: 'delete'
  })
}

export function updateStatus(id, enabledMark) {
  return request({
    url: `/api/system/Permission/Users/updateStatus/${id}/${enabledMark}`,
    method: 'post'
  })
}

export function restPassword(id, data) {
  return request({
    url: '/api/system/Permission/Users/' + id + '/Actions/ResetPassword',
    method: 'post',
    data: data
  })
}

export function restNewPassword(data) {
  return request({
    url: '/api/system/Permission/Users/Current/Actions/ModifyPassword',
    method: 'post',
    data: data
  })
}

export function usersSelector() {
  return request({
    url: '/api/system/Permission/Users/Selector',
    method: 'get'
  })
}

export function getList(data) {
  return request({
    url: '/api/system/Permission/Users',
    method: 'get',
    params:data
  })
}
